export const removeDuplicatesFromArray = (files) => {
    const seenIds = new Set();
    return files.filter((file) => {
      if (seenIds.has(file.id)) {
        return false;
      } else {
        seenIds.add(file.id);
        return true;
      }
    });
  };
  export function removeProperty(obj, key) {
    const { [key]: removed, ...rest } = obj;
    return rest;
  }
  